import React from 'react';
import { Box, Button, Icon, Text, Flex } from '@chakra-ui/react';
import { FaTimesCircle } from 'react-icons/fa';

const DeleteConfirmation = ({ isOpen, onConfirm, onClose }) => {
  // Only render the dialog if `isOpen` is true
  if (!isOpen) return null;

  return (
    <Flex justify="center" align="center" position="fixed" top="0" left="0" width="100vw" height="100vh" bg="rgba(0, 0, 0, 0.4)">
      <Box
        width="400px"
        padding="20px"
        borderRadius="md"
        boxShadow="lg"
        bg="white"
        textAlign="center"
      >
        <Icon as={FaTimesCircle} color="red.500" boxSize={12} mb={4} />
        <Text fontSize="xl" fontWeight="bold" mb={4}>
          Are you sure?
        </Text>
        <Text mb={6}>
          Do you really want to delete this record? This process cannot be undone.
        </Text>
        <Flex justify="space-between" mt={4}>
          <Button
            width="48%"
            bg="gray.300"
            color="white"
            _hover={{ bg: 'gray.400' }}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            width="48%"
            bg="red.500"
            color="white"
            _hover={{ bg: 'red.600' }}
            onClick={onConfirm}
          >
            Delete
          </Button>
        </Flex>
      </Box>
    </Flex>
  );
};

export default DeleteConfirmation;
